'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var Typography = require('../../DesignSystem/DataDisplay/Typography/Typography.js');
var classNames = require('classnames');
var React = require('react');
require('prop-types');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var style = function style(theme) {
  return {
    imageContainer: {
      textAlign: 'center',
      WebkitBoxFlex: 0,
      verticalAlign: 'middle',
      width: 350,
      height: 245
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    },
    description: {
      marginTop: 8,
      paddingLeft: 32,
      paddingRight: 32,
      WebkitBoxFlex: 1
    },
    webkitBoxContainer: defineProperty({
      display: '-webkit-box',
      width: '100%',
      WebkitBoxOrient: 'vertical'
    }, theme.breakpoints.up('sm'), {
      WebkitBoxOrient: 'horizontal'
    }),
    webkitBoxContainerPDF: {
      WebkitBoxOrient: 'horizontal'
    },
    inline: {
      whiteSpace: 'pre-line',
      display: 'inline'
    }
  };
};

var OptionInvoiceDescription = function OptionInvoiceDescription(_ref) {
  var classes = _ref.classes,
      option = _ref.option,
      image = _ref.image,
      isPDF = _ref.isPDF;
  var description = option.description;
  var url = image.url;
  return React__default["default"].createElement("div", {
    className: classNames__default["default"](classes.webkitBoxContainer, isPDF && classes.webkitBoxContainerPDF)
  }, url && React__default["default"].createElement("div", {
    className: classes.imageContainer
  }, React__default["default"].createElement("img", {
    src: url,
    className: classes.image
  })), React__default["default"].createElement("div", {
    className: classNames__default["default"](defineProperty({}, classes.description, url))
  }, React__default["default"].createElement(Typography, {
    className: classes.inline
  }, description)));
};

var OptionDescription = withStyles(style)(OptionInvoiceDescription);
OptionInvoiceDescription.defaultProps = {
  isPDF: false
};

module.exports = OptionDescription;
